import React, { useState } from "react";
import { useEffect } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import useProcesoMatricula from "../hooks/useProcesoMatricula";
import {
  insert_reglamentosAceptados,
  reglamentoEstudio,
} from "../services/Matricula";
import {
  listado_datos_personales,
  update_paso,
} from "../services/procesoMatricula/procesoMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import { construirUrlS3 } from "../utils/utils";

const ReglamentosDeEstudios = () => {
  const {
    procesoMatricula,
    setProcesoMatricula,
    seteoDeObjectMatricula,
    obtenerDatosEstudiante,
  } = useMatricula();
  const {
    setObtenerReglamentoEstudios,
    obtenerReglamentoEstudios,
    setSeleccionPdf,
    setPasoProcesoM,
    setListadoDatosPersonales,
    setLoading,
    setErrorServices,
    setErrorCursoServices
  } = useProcesoMatricula();

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});

  const [checkedState, setCheckedState] = useState([]);
  const [mensaje, setMensaje] = useState({});


  useEffect(() => {
    const { cinstitucion } = obtenerDatosEstudiante;
    if (cinstitucion) {
      try {

        reglamentoEstudio(
          obtenerDatosEstudiante,
          setObtenerReglamentoEstudios,
          setLoading
        );

      } catch (error) {
      } finally {

      }
    }
  }, [obtenerDatosEstudiante]);

  useEffect(() => {
    if ([obtenerReglamentoEstudios].length > 0) {
      let dataReglamento = obtenerReglamentoEstudios.map((data) => {
        return data.bacepto;
      });
      if (dataReglamento.length > 0) {
        setCheckedState(dataReglamento);
      }
    }
  }, [obtenerReglamentoEstudios]);

  const handleOnChange = (cdocumento, index) => {
    let listcheck = checkedState.map((data, i) => {
      if (i == index) {
        return !data;
      }
      return data;
    });

    setCheckedState(listcheck);


  };

  const atrasBtnReglametos = async () => {

    try {
      setLoading(true);

      let pasosOk = await update_paso(obtenerDatosEstudiante, 0, 1);
      let convertirPasoCompletadoMayoCero = Number(pasosOk.Data.paso_siguiente);
      let convertirPasoCompletado =
        convertirPasoCompletadoMayoCero > 0
          ? convertirPasoCompletadoMayoCero - 1
          : convertirPasoCompletadoMayoCero;
      setPasoProcesoM(convertirPasoCompletado);

    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const retornarListaCdocumento = () => {
    let cdocumentos = obtenerReglamentoEstudios.map((data) => {
      return data.cdocumento;
    });
    return String(cdocumentos.join(","));
  };
  const validarBtnReglametos = async () => {
    if (checkedState.includes(false)) {
      setMensaje({ msj: `*${lbl_validacion_msj_todos_campos}.` });
    } else {
      setMensaje({});

      let cdocumento = retornarListaCdocumento();

      try {
        setLoading(true);
        let insertarOk = await insert_reglamentosAceptados(
          obtenerDatosEstudiante,
          {
            cdocumento,
            baceptado: true,
          }
        );
        if (insertarOk.StatusCode == 200 && insertarOk.Data.respuesta == 1) {
          let pasosOk = await update_paso(obtenerDatosEstudiante, 2, 1);
          if (pasosOk.StatusCode == 200 && pasosOk.Code == 1) {
            let convertirPasoCompletadoMayoCero = Number(
              pasosOk.Data.paso_siguiente
            );
            let convertirPasoCompletado =
              convertirPasoCompletadoMayoCero > 0
                ? convertirPasoCompletadoMayoCero - 1
                : convertirPasoCompletadoMayoCero;
            setPasoProcesoM(convertirPasoCompletado);

            // setPasoProcesoM(2);
          } else {
            throw pasosOk.Message;
          }
        } else {
          throw insertarOk.Message;
        }
      } catch (error) {
        setLoading(false);
        let modalErrorr = document.querySelector("#modalErr");

        if (modalErrorr) {
          modalErrorr.click();
          // setErrorServices(true);
          setErrorCursoServices(error)
        }
      } finally {
        setLoading(false);
      }
    }

  };

  useEffect(() => {

    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_reglamento_estudio: obtenerLabelEtiqueta(
          "lbl_global_reglamento_estudio",
          listadoEtiquetas
        ),
        reglamento_declaracion: obtenerLabelEtiqueta(
          "lbl_reglamento_declaracion",
          listadoEtiquetas
        ),
        msj_declaro: obtenerLabelEtiqueta(
          "lbl_reglamento_msj_declaro",
          listadoEtiquetas
        ),
        reglamento_generales: obtenerLabelEtiqueta(
          "lbl_reglamento_generales",
          listadoEtiquetas
        ),
        reglamento_volver: obtenerLabelEtiqueta(
          "lbl_reglamento_volver",
          listadoEtiquetas
        ),
        datos_continuar: obtenerLabelEtiqueta(
          "lbl_update_datos_continuar",
          listadoEtiquetas
        ),
        lbl_validacion_msj_todos_campos: obtenerLabelEtiqueta(
          "lbl_validacion_msj_todos_campos",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const {
    global_reglamento_estudio,
    reglamento_declaracion,
    msj_declaro,
    reglamento_generales,
    reglamento_volver,
    datos_continuar,
    lbl_validacion_msj_todos_campos,
  } = etiquetas;

  return (
    <div className="col-sm-12 col-md-12 col-lg-12 steps-container ">
      <div className="card shadow-sm">
        <div className="card-body">
          <fieldset>
            <div className="form-body">
              <div className="matricula-title">
                <h5 className="text-uppercase">{global_reglamento_estudio}</h5>
                <div className="separator"></div>
              </div>
              <p className="fw-medium text-uppercase">
                {reglamento_declaracion}
              </p>
              <p className="fw-regular">{msj_declaro}.</p>
              <p className="fw-regular">{reglamento_generales}:</p>
              <ul>
                {obtenerReglamentoEstudios.map((data, index) => {
                  return (
                    <li className="mb-2" key={data.cdocumento}>
                      <label className="container-checkbox d-inline-block">
                        <input
                          type="checkbox"
                          id={`custom-checkbox-${index}`}
                          checked={checkedState[index]}
                          onChange={() =>
                            handleOnChange(data.cdocumento, index)
                          }
                        />
                        <span className="checkmark"></span>
                      </label>
                      <button
                        className="btn p-0"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        onClick={() => {
                          setSeleccionPdf({
                            ruta: data.url ?? data.druta ?? construirUrlS3(data.bucket_s3, data.key_s3),
                            title: data.tdocumento,
                          });
                        }}
                      >
                        <p className="text-black text-underline mb-0 text-decoration-underline">
                          {data.tdocumento}
                        </p>
                      </button>
                    </li>
                  );
                })}
              </ul>
              {mensaje.msj && (
                <p className="msjActualizacionDatos">{mensaje.msj}</p>
              )}
              <p></p>
            </div>
            <button
              type="button"
              className="btn waves-effect waves-light btn-light-secondary previous"
              onClick={atrasBtnReglametos}
            >
              {reglamento_volver}
            </button>
            <button
              type="button"
              className="btn waves-effect waves-light btn-primary next"
              onClick={validarBtnReglametos}
            >
              {datos_continuar}
            </button>
          </fieldset>
        </div>
      </div>

      <button
        style={{ display: "none" }}
        data-bs-toggle="modal"
        data-bs-target="#error"
        id="modalErr"
      ></button>
    </div>
  );
};

export default ReglamentosDeEstudios;
